import { render } from "./BtnLinks.vue?vue&type=template&id=6d796e31"
import script from "./BtnLinks.vue?vue&type=script&lang=js"
export * from "./BtnLinks.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__